<template>
  <div class="opt-out-input-file">
    <b v-if="title">{{ title }}</b>
    <div v-if="typeFile || sizeInfo" class="file-label d-flex mt-3">
      <h4 v-if="typeFile">{{ typeFile }}</h4>
      <span v-if="sizeInfo">{{ sizeInfo }}</span>
    </div>
    <div
      :style="`background-image: url(${backgroundImage})`"
      v-if="!file"
      class="background-image"
    >
      <div
        style="border: 1px solid #E8E8E8; margin-top: 10px"
        :class="[boxFileClass, 'box-file', dragging ? 'box-file-over' : '']"
        @dragenter="dragging = true"
        @dragleave="dragging = false"
      >
        <div @drag="onChange">
          <div class="box-file-info">
            <span>
              {{ textBox }} <br v-if="typeFile" />
              <b v-if="typeFile">{{ typeFile }}</b> ou
            </span>
          </div>
          <div class="box-file-input">
            <button class="btn">
              Escolha um arquivo
            </button>
          </div>
        </div>
        <input :accept="accept" type="file" @change="onChange" />
      </div>
    </div>
    <div v-else class="box-file">
      <div class="preview-img-container">
        <img class="preview-img mr-2 mb-2" :src="previewImg" />
        <span class="file-name">
          {{ this.file.name }}
        </span>
        <button class="remove-file" @click="removeFile">
          <Icon icon="x-icon" />
        </button>
      </div>
    </div>
    <div v-show="this.boxFileClass === 'is-invalid'" class="cl-red-primary">
      <small v-if="errorMinSize"
        >O arquivo selecionado é menor que o tamanho permitido</small
      >
      <small v-if="errorMaxSize"
        >O arquivo selecionado é maior que o tamanho permitido</small
      >
    </div>
  </div>
</template>

<script>
import csvIcon from '@/assets/images/csv-icon.jpg'
export default {
  name: 'opt-out-input-file',
  props: {
    /** Título */
    title: {
      type: String,
      default: null
    },
    /**
     * Titulo de arquivo. Funciona como um subtítulo
     * TODO modificar esse nome porque não condiz com a função
     */
    typeFile: {
      type: String,
      default: null
    },
    /** Informação sobre o tamanho do arquivo. Funciona como um subtítulo */
    sizeInfo: {
      type: String,
      default: null
    },
    /** Tamanho minímo do arquivo */
    minSize: {
      type: Number,
      default: 0
    },
    /** Tamanho máximo do arquivo */
    maxSize: {
      type: Number,
      default: 500
    },
    /** Edita um texto dentro do container */
    textBox: {
      type: String,
      default: 'Arraste aqui a imagem'
    },
    /** Adiciona uma imagem de background */
    backgroundImage: {
      type: String,
      default: 'https://letsimage.s3.sa-east-1.amazonaws.com/Common/logo.png'
    },
    /** Extensões de arquivos permitidas */
    accept: {
      type: String,
      default: ''
    },
    /** Valor do arquivo que foi carregado */
    value: {
      type: [String, File],
      default: ''
    }
  },
  data: function() {
    return {
      file: '',
      fileCheck: false,
      dragging: false,
      fileClass: false,
      boxFileClass: '',
      errorMinSize: false,
      errorMaxSize: false,
      previewImg: null
    }
  },
  computed: {
    isDisabledFile() {
      return this.fileCheck
    }
  },
  watch: {
    value(newValue) {
      if (!newValue) {
        this.removeFile()
      }
    }
  },
  methods: {
    onChange(e) {
      const files = e.target.files || e.dataTransfer.files
      if (!files.length) {
        this.dragging = false
        return
      }
      this.createImage(files[0])
    },
    convertSize(size) {
      return size ? (size / 1024).toFixed(2) : null
    },
    createImage(file) {
      const sizeConverted = this.convertSize(file.size)
      if (sizeConverted < this.minSize) {
        this.errorMinSize = true
        this.boxFileClass = 'is-invalid'
      } else if (sizeConverted > this.maxSize) {
        this.errorMaxSize = true
        this.boxFileClass = 'is-invalid'
      } else {
        const reader = new FileReader()

        this.boxFileClass = ''
        this.file = file
        this.fileCheck = true
        this.dragging = false

        reader.onload = (e) => {
          const isImage =
            e.target.result
              .split(';')[0]
              .search(/data:image\/(png|jpg|jpeg|gif|bmp)/gim) > -1

          this.previewImg = isImage ? e.target.result : csvIcon
          this.$emit('changeFile', file)
          this.$emit('input', file)
          this.$emit('changeImage', this.image)
        }
        reader.readAsDataURL(file)
      }
    },
    removeFile() {
      this.file = ''
      this.fileCheck = false
    }
  }
}
</script>

<style lang="scss" scoped>
.opt-out-input-file {
  .file-label {
    h4 {
      font-size: 16px;
      font-weight: 300;
      margin-right: 10px;
    }
    span {
      font-size: 14px;
      font-weight: 400;
      color: color(gray, 50);
    }
  }
  .background-image {
    background-repeat: no-repeat;
    background-size: contain;
  }
  .box-file {
    display: flex;
    width: 100%;
    height: auto;
    padding: 30px 45px;
    border: 1px solid color(gray, 9);
    position: relative;
    cursor: pointer;
    justify-content: center;
    &:hover {
      button {
        background-color: color(gray, 3);
      }
    }
    &.box-file-over {
      background-color: color(gray, 3);
    }
    &.is-invalid {
      border-width: 2px;
      border-color: color(red, primary);
    }
    input {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      opacity: 0;
      cursor: pointer;
    }
    .box-file-info {
      img.preview-img {
        max-width: 82px;
        height: auto;
        box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
      }
      span {
        display: block;
        font-size: 12px;
        font-weight: 400;
        text-align: center;
        color: #7f7f7f;
      }
    }
    .box-file-input {
      margin-top: 16px;
      color: #7f7f7f;
      button {
        font-size: 12px;
        font-style: normal;
        font-weight: 500;
        text-align: center;
        text-decoration: underline;
        color: #7f7f7f;
        border-color: #7f7f7f;
        border: dashed 1px #7f7f7f;
        border-radius: 4px;
        &:hover {
          border-color: inherit;
          box-shadow: none;
          color: #7f7f7f;
        }
      }
    }
  }

  .preview-img-container {
    position: relative;
    display: inline-flex;
    flex-wrap: wrap;
    width: auto;
    max-width: 250px;
    justify-content: center;

    .preview-img {
      width: 100%;
      max-width: 80px;
    }

    .file-name {
      display: block;
      width: 100%;
      text-align: center;
    }
  }
  .remove-file {
    @include reset-button();
    position: absolute;
    right: 0;
    top: 0;
    width: 25px;
    height: 25px;
    background-color: $primary;
    color: $white;
    border-radius: 50%;
    transform: translate(50%, -50%);

    .icon {
      width: 10px;
      height: 10px;
    }
  }
}
</style>
